// removed by extract-text-webpack-plugin
module.exports = {"item":"Status__item___2geMq","label":"Status__label___3CS1R","value":"Status__value___2LuqZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Status.css
// module id = 110
// module chunks = 0